import classNames from "classnames";
import React, { FunctionComponent } from "react";
import { WithTranslation, withTranslation } from "react-i18next";
// import GotQuestionsBtn from "Shared/GotQuestionsBtn";
import { Desktop } from "Shared/Responsive";
import { AccessoriesPanel } from "src/components/Accessories";
import useSelector from "src/utils/useSelector";
import StepContent from "../StepContent/StepContent";
import "./CustomizeVehicle.scss";

interface Props {
    className?: string;
    vin: string;

    onAccessoriesChange?(): void;
    onBackClick?(): void;
    onNextClick?(): void;
    onSkipClick?(): void;
}

const CustomizeVehicle: FunctionComponent<Props & WithTranslation> = ({
    className,
    vin,
    onAccessoriesChange,
    onBackClick,
    onNextClick,
    onSkipClick,
    t,
}) => {
    const label = useSelector((state) => state.account.account_disclaimers.upgrades_label);

    return (
        <div className={classNames("CustomizeVehicle", className)}>
            <div className={"CustomizeVehicle__header"}>
                <h1 className={"CustomizeVehicle__title"}>{t("ContinueDeal.CustomizeVehicle.title")}</h1>
            </div>

            <Desktop>
                <hr className="CustomizeVehicle__header-horizontal-line" />
            </Desktop>

            <div className="CustomizeVehicle__main">
                <StepContent
                    nextText={t("ContinueDeal.StepContent.next")}
                    onBackClick={onBackClick}
                    onNextClick={onNextClick}
                    skipText={t("ContinueDeal.CustomizeVehicle.skip", { label: label.toLowerCase() })}
                    onSkipClick={onSkipClick}
                >
                    <div className="CustomizeVehicle__accessories">
                        <AccessoriesPanel vin={vin} onAccessoriesChange={onAccessoriesChange!} />
                    </div>
                </StepContent>
            </div>
        </div>
    );
};

export default withTranslation()(CustomizeVehicle);
